exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-confirmar-cierre .modal-dialog.modal-sm {\n  max-width: 480px; }\n\n.modal-confirmar-cierre .modal-header {\n  padding: 18px 24px; }\n\n.modal-confirmar-cierre .modal-title {\n  font-size: 20px;\n  font-weight: 600; }\n\n.modal-confirmar-cierre .modal-body {\n  padding: 20px 24px 8px 24px;\n  font-size: 15px;\n  line-height: 1.5;\n  text-align: left; }\n\n.modal-confirmar-cierre .resumen {\n  width: 100%;\n  margin-bottom: 14px; }\n\n.modal-confirmar-cierre .resumen td {\n  padding: 5px 0;\n  vertical-align: top; }\n\n.modal-confirmar-cierre .resumen .etiqueta {\n  width: 40%;\n  opacity: 0.75; }\n\n.modal-confirmar-cierre .resumen .valor {\n  font-weight: 600; }\n\n.modal-confirmar-cierre .nota {\n  font-size: 14px;\n  opacity: 0.85;\n  margin-bottom: 6px; }\n\n.modal-confirmar-cierre .pregunta {\n  font-weight: 600;\n  margin-bottom: 0; }\n\n.modal-confirmar-cierre .modal-footer {\n  padding: 14px 24px; }\n\n.modal-confirmar-cierre .modal-footer .btn {\n  min-width: 100px;\n  margin-left: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalConfirmarCierre/modalConfirmarCierre.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalConfirmarCierre/modalConfirmarCierre.scss
// module chunks = 14